import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { map } from 'rxjs/operators';

import { SmartSmsService } from '../../../core/api/services';
import { BaseApiChipListSelectSearch } from './base/base-api-chip-list-select-search.component';
import { BaseApiChipListSelectSearchModule } from './base/base-api-chip-list-select.search.module';
@Component({
  selector: 'brand-models-api-chip-list-select-search',
  templateUrl: './base/base-api-chip-list-select-search-template.html',
  standalone: true,
  imports: [BaseApiChipListSelectSearchModule],
})
export class BrandModelsApiChipListSelectSearchComponent
  extends BaseApiChipListSelectSearch
  implements OnInit
{
  @Input() brandName: string;
  @Input() filteredValue: string;

  constructor(protected currentService: SmartSmsService) {
    super();
  }

  initConfig() {
    super.initConfig();
    if (!this.label) this.label = 'common.brandModel';
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes['id']) this.values = [];
    if (changes['brandName'] || changes['filteredValue']) {
      // this.values = [];
      this.getItemsApi();
    }
  }

  getItemsApi() {
    if (!this.brandName) {
      this.initLoading = false;
      return;
    }

    if (!this.filteredValue || this.filteredValue.length >= 3) {
      if (this.subscription) this.subscription.unsubscribe();

      this.subscription = this.currentService
        .smartSmsGetDeviceModelsByBrand({
          BrandName: this.brandName,
          DeviceModelFilter: this.filteredValue || '', // Pass empty string if no filter
        })
        .pipe(
          this.basePipeOperators(),
          map((items) => {
            return items.data.map((item) => ({
              ...item,
              optionTitle: `${item.name}`,
            }));
          })
        )
        .subscribe(this.baseObserver);
    }
  }
}
